const milestones = [
  {
    year: "2016",
    title: "Company Established",
    desc: "Urban Infra was founded in Bengaluru with a vision to bring transparency and quality to residential real estate development on Sarjapur Road.",
    icon: "ri-flag-2-fill",
  },
  {
    year: "2016",
    title: "First Project Started",
    desc: "Launched our first residential layout development on Sarjapur Road, setting the standard for planned, infrastructure-ready communities.",
    icon: "ri-layout-grid-fill",
  },
  {
    year: "2017",
    title: "Expansion",
    desc: "Expanded into premium villa and villa plot development along Sarjapur Road — one of Bengaluru's fastest-growing real estate corridors.",
    icon: "ri-home-4-fill",
  },
  {
    year: "2022",
    title: "500+ Families Served",
    desc: "Crossed a major milestone — over 500 families now call an Urban Infra development their home across Bengaluru.",
    icon: "ri-home-heart-fill",
  },
  {
    year: "2026+",
    title: "Growing Forward",
    desc: "Continuing to expand our portfolio with new residential communities, premium plots, and innovative housing solutions on Sarjapur Road, Bangalore.",
    icon: "ri-rocket-fill",
  },
];

export default function Timeline() {
  return (
    <section className="bg-white py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-[#EAF5E1] px-3 py-1.5 rounded-full mb-4">
            Our Journey
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A]" style={{ fontFamily: "'Playfair Display', serif" }}>
            A Decade of Building Trust
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Center line (desktop) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#EAF5E1] -translate-x-1/2"></div>

          <div className="flex flex-col gap-10 md:gap-0">
            {milestones.map((m, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={`${m.year}-${i}`}
                  className={`relative flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-0 ${
                    isLeft ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  {/* Content card */}
                  <div className={`w-full md:w-[calc(50%-2.5rem)] ${isLeft ? "md:pr-8 md:text-right" : "md:pl-8 md:text-left"}`}>
                    <div className={`bg-white border border-gray-100 rounded-2xl p-6 hover:border-[#7FBF3F]/30 transition-all duration-300 group ${isLeft ? "md:ml-auto" : ""}`}>
                      <div className={`flex items-center gap-2 mb-3 ${isLeft ? "md:justify-end" : ""}`}>
                        <span className="font-serif text-2xl font-bold text-[#1B2A4A]" style={{ fontFamily: "'Playfair Display', serif" }}>{m.year}</span>
                      </div>
                      <h3 className="text-sm font-bold text-[#1B2A4A] mb-2">{m.title}</h3>
                      <p className="text-xs text-gray-500 leading-relaxed">{m.desc}</p>
                    </div>
                  </div>

                  {/* Center dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-10 h-10 items-center justify-center bg-[#1B2A4A] rounded-full z-10 flex-shrink-0">
                    <i className={`${m.icon} text-white text-sm`}></i>
                  </div>

                  {/* Mobile dot */}
                  <div className="md:hidden flex items-center gap-3 -mt-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#1B2A4A] rounded-full flex-shrink-0">
                      <i className={`${m.icon} text-white text-xs`}></i>
                    </div>
                    <span className="font-serif text-lg font-bold text-[#1B2A4A]">{m.year}</span>
                  </div>

                  {/* Spacer for opposite side */}
                  <div className="hidden md:block w-[calc(50%-2.5rem)]"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
